"use client";

import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex items-center gap-6">
        <div className="h-6 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-6 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="group relative inline-block text-sm font-medium text-foreground transition-all duration-300 ease-out hover:-translate-y-0.5 px-0 hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent animate-fade-in-up" style={{
          animationDelay: `${i * 100}ms`
        }}>
              <Link to={item.href || "#"}>
                {item.label}
                <span className="absolute bottom-0 left-0 h-px w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full group-hover:shadow-[0_0_8px_rgba(58,91,191,0.4)]" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  return <header className="w-full bg-light-background border-b border-border">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          
        </div>

        <div className="flex items-center gap-6">
          <MenuProvider menu_id="3">
            <HeaderNavigation />
          </MenuProvider>
        </div>
      </div>
    </header>;
}